<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import {
  BModal, BButton, BAlert, BRow, BCol, BFormGroup, BFormCheckbox, AlertPlugin,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import { required, email } from '@validations';
import axios from '@/libs/axios';

export default {
  components: {
    BModal,
    BButton,
    BAlert,
    vSelect,
    BRow,
    BCol,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        regraid: '',
        regradescricao: '',
      }),
      require: true,
    },
    titleModal: {
      type: String,
      default: null,
      require: false,
    },
    idModal: {
      type: String,
      default: null,
      require: false,
    },
    labelBtnOk: {
      type: String,
      default: null,
      require: false,
    },
  },
  data() {
    return {
      dataFromApiRegratipo: [
        { tipo_regra: 'SELECT', regratipodescricao: 'SELECT' },
        { tipo_regra: 'CREATE', regratipodescricao: 'CREATE' },
        { tipo_regra: 'UPDATE', regratipodescricao: 'UPDATE' },
        { tipo_regra: 'DELETE', regratipodescricao: 'DELETE' },
        { tipo_regra: 'INSERT', regratipodescricao: 'INSERT' },
      ],
    };
  },
  computed: {
    dataForm: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    async validateForm() {
      this.$emit('ok', this.dataForm);
      this.$bvModal.hide(this.idModal);
    },
  },
};
</script>

<template>
  <b-modal
      ref="modalAtt"
      no-close-on-backdrop
      no-close-on-esc
      size="xl"
      :id="idModal"
      :title="titleModal"
      :ok="dataForm.isDefault || dataForm.regradescricao === ''"
      :ok-title="labelBtnOk"
      ok-variant="success"
      cancel-variant="danger"
      body-bg-variant="light"
      cancel-title="Cancelar Alteração"
      @ok="validateForm"
      @cancel="$emit('cancel')"
      @close="$emit('cancel')"
  >
    <validation-observer ref="refFormData">
      <b-form @submit.prevent>
        <b-row>
          <b-col
              cols="4"
              class="mb-1"
          >
            <b-form-group
                label="Nome da Regra"
                label-for="nome_regra"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Descrição"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.nome_regra"
                    id="nome_regra"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Digite o nome"
                    disabled
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="4"
              class="mb-1"
          >
            <b-form-group
                label="Descrição"
                label-for="descricao_regra"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Descrição"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.descricao_regra"
                    type="text"
                    id="descricao_regra"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Digite a descricao"
                    disabled
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="4"
              class="mb-1"
          >
            <b-form-group
                label="Tipo Regra"
                label-for="tipo_regra"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Descrição"
                  rules="required"
              >
                <b-form-select
                    v-model="dataForm.tipo_regra"
                    id="tipo_regra"
                    :state="errors.length > 0 ? false : null"
                    :options="dataFromApiRegratipo"
                    value-field="tipo_regra"
                    text-field="regratipodescricao"
                    placeholder="Selecione uma utilização"
                    disabled
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="12"
              class="mb-1"
          >
            <b-form-group
                label="Comando (query)"
                label-for="comando"
            >
              <validation-provider
                  #default="{ errors }"
                  name="comando"
                  rules="required"
              >
                <b-form-textarea
                    v-model="dataForm.comando"
                    id="comando"
                    :state="errors.length > 0 ? false:null"
                    rows="10"
                    placeholder="Digite o comando"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-modal>
</template>
